// Mapa de direcciones del CRM XmarteK (D19). Todo vive bajo *.crm.xmartek.co:
//   <empresa>.crm.xmartek.co        el CRM de esa empresa (esta Consola)
//   <empresa>-admin.crm.xmartek.co  su panel tecnico (Twenty); se abre con el boton "Configuracion avanzada"
//   crm.xmartek.co                  entrada general: iniciar sesion y elegir empresa
//   portal.crm.xmartek.co           portal de control de Xmartek
export const DOMINIO = import.meta.env.VITE_DOMINIO_CRM || 'crm.xmartek.co';
export const RESERVADOS = new Set(['portal', 'admin', 'app', 'www', 'api']);
const SUFIJO_ADMIN = '-admin';

const primerNombre = (url: string) => {
  try {
    return new URL(url).hostname.split('.')[0];
  } catch {
    return '';
  }
};

// Empresa que indica la direccion en la que se abrio la Consola (null en crm.xmartek.co o en localhost).
export function empresaDelHost(hostname = location.hostname): string | null {
  const sufijo = `.${DOMINIO}`;
  if (!hostname.endsWith(sufijo)) return null;
  const nombre = hostname.slice(0, -sufijo.length);
  if (!nombre || nombre.includes('.') || RESERVADOS.has(nombre) || nombre.endsWith(SUFIJO_ADMIN)) return null;
  return nombre;
}

// Nombre de la empresa a partir de la URL de su workspace en Twenty ("acme-admin" -> "acme").
export const empresaDeWorkspace = (url: string) => primerNombre(url).replace(/-admin$/, '');

// La direccion del CRM de una empresa (la que se entrega al cliente y se pone en su 3CX).
export const urlCrm = (workspaceUrl: string) => {
  const e = empresaDeWorkspace(workspaceUrl);
  return e ? `https://${e}.${DOMINIO}` : `https://${DOMINIO}`;
};

// El panel tecnico de una empresa (Twenty con marca XmarteK).
export const urlConfiguracionAvanzada = (workspaceUrl: string) => {
  const e = empresaDeWorkspace(workspaceUrl);
  return e ? `https://${e}${SUFIJO_ADMIN}.${DOMINIO}` : workspaceUrl;
};
